export default function (options: Array<{ label: string; value: string | number }>, value: any, direction: boolean) {
  if (value === undefined) {
    return options
  }

  const valueIndex = options.findIndex((option) => option.value === value)

  if (valueIndex === -1) {
    return options
  }

  return options.filter((_option, currentIndex) => {
    return direction ? currentIndex >= valueIndex : currentIndex <= valueIndex
  })
}
